var SignUpButton  = require("app/Auth/SignUpButton"),
    config        = require("app/config"),
    frameThrottle = require("enyo-perf/utils").frameThrottle,
    get           = require("object-path").get,
    isIosApp      = require("app/utils/isIosApp"),
    kind          = require("enyo/kind");

require("./SignUpCta.less");
require("app/theme/IconButton--positive.less");

module.exports = kind(/** @lends  app.UserRequiredPage.SignUpCta.prototype */ {

    /**
     * @private
     */
    name: "app.UserRequiredPage.SignUpCta",

    /**
     * @private
     */
    classes: "app-user-required-page-sign-up-cta",

    /**
     * Don't show if signup is disabled or if we're running as IOS app
     *
     * @private
     */
    canGenerate: get(config, "signup.enabled", true) && !isIosApp,

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @private
     */
    state: null,

    /**
     * @private
     */
    components: [{
        name:    "title",
        classes: "app-user-required-page-sign-up-cta__title",
        tag:     "h1"
    }, {
        name:    "body",
        classes: "app-user-required-page-sign-up-cta__body",
        tag:     "p"
    }, {
        name:    "signUpButton",
        kind:    SignUpButton,
        classes: "app-user-required-page-sign-up-cta__sign-up-button",
        theme:   "positive"
    }],

    /**
     * @private
     */
    handlers: {
        onCancelButtonTap: "onCancelButtonTap"
    },

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @public
     */
    update: function() {
        var state                = this.state || {},
            i18nService          = this.app.$.i18nService,
            defaultMonthPrice    = get(state, "defaultMonthOffer.payment_amount", null),
            defaultMonthCurrency = get(state, "defaultMonthOffer.currency_code", null);

        this.$.title.set("content", i18nService.getString("app.UserRequiredPage.SignUpCta.title"));

        if (defaultMonthPrice !== null) {
            this.$.body.set("content", i18nService.getString("app.UserRequiredPage.SignUpCta.bodyWithPrice", {
                price: new Intl.NumberFormat(i18nService.get("locale"), {
                    style:    "currency",
                    currency: defaultMonthCurrency
                }).format(defaultMonthPrice / 100)
            }));
        }
        else {
            this.$.body.set("content", i18nService.getString("app.UserRequiredPage.SignUpCta.bodyWithoutPrice"));
        }
    }

});
